module.exports = __webpack_public_path__ + "media/images/products/wedding/icon/icon-download-036966a66c7dc2e38d72678499c40b3e.svg";